<template>
  <div class="vuse-content-wrapper contact-app">
    <vuse-section-definition :title="page" icon="view_list" />
    <v-container fluid class="">
      <v-row>
        <v-col cols="12" lg="3" md="3" sm="4"
          ><v-text-field
            v-model="filter.SearchTerm"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            solo
          ></v-text-field
        ></v-col>

        <v-col cols="12" lg="3" md="3" sm="4">
          <TagsSelect
            v-model="filter.tags"
            label="Filter by Tags"
            hide-details
            solo
            clearable
            multiple
            dense
          />
        </v-col>

        <v-col cols="12" lg="6" md="6" sm="4" class="text-right">
          <v-btn
            color="info"
            dark
            class="mb-2"
            @click="onNew()"
            v-show="hasAccess('item.add')"
          >
            Add Item
          </v-btn>
        </v-col>
      </v-row>
      <template>
        <v-card>
          <v-data-table
            :headers="activeHeaders"
            :items="$store.getters['item/getAll']"
            :options.sync="tableOptions"
            :server-items-length="totalItems"
            class="elevation-1"
            :loading="loading"
            @click:row="onEdit"
            :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50, 100, 200] }"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-menu offset-y :close-on-content-click="false">
                  <template v-slot:activator="{ on }">
                    <v-btn rounded class="content-ma-0 mr-2" v-on="on" x-small>
                      <v-icon small>menu</v-icon> Customize Columns
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item dense :key="i" v-for="(header, i) in headers">
                      <v-list-item-title v-if="header.readonly">
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                          :disabled="true"
                        />
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        <v-checkbox
                          v-model="headers[i].active"
                          :label="header.text"
                        />
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-toolbar>
            </template>

            <template v-slot:item.lastUpdated="{ item }">
              <v-chip @click="onEdit(item)" small>
                {{ item.lastUpdated | formatDatetime }}
              </v-chip>
            </template>
            <template v-slot:item.price="{ item }">
              {{ item.price | formatPrice }}
            </template>

            <template v-slot:item.categories="{ item }">
              <TagsChip :value="item.categories" />
            </template>

            <template v-slot:item.cost="{ item }">
              {{ item.cost | formatPrice }}
            </template>

            <template v-slot:item.actions="{ item }">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon small class="content-ma-0" v-on="on">
                    <v-icon small>mdi-cogs</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <!-- <v-list-item @click="onDetail(item)">
                    <v-list-item-title>
                      <v-icon small left>person</v-icon>Detail
                    </v-list-item-title>
                  </v-list-item> -->
                  <v-list-item
                    @click="onEdit(item)"
                    v-show="hasAccess('item.edit')"
                  >
                    <v-list-item-title>
                      <v-icon small left>mdi-pencil</v-icon>Edit
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onDelete(item)"
                    v-show="hasAccess('item.delete')"
                  >
                    <v-list-item-title>
                      <v-icon small left>delete</v-icon>Delete
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data>
              <span v-text="noRecordFound"></span>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-container>

    <add-form
      :item="selectedItem"
      :show="showEdit"
      @onClosed="clearEdit()"
      @onSucceded="refresh()"
    />
    <delete-dialog
      :item="selectedItem"
      :show="showDelete"
      @onSucceded="refresh()"
      @onClosed="clearDelete()"
    />
    <detail
      :item="selectedItem"
      :show="showDetail"
      @onSucceded="refresh()"
      @onClosed="clearDetail()"
    />
  </div>
</template>
<script>
import AddForm from "./Item/_Form";
import DeleteDialog from "./Item/_Delete";
import Detail from "./Item/_Detail";
import { mapState, mapActions, mapGetters } from "vuex";
import _ from "lodash";
import TagsSelect from "components/TagSelect.vue";
import TagsChip from "components/TagsChip";
import formatterMixin from "@/mixins/formatterMixin";
import { getStorage, setStorage } from "src/utils/helpers";

const SETTING_LIST_KEY = "items-columns";
const defaultHeaders = [
  {
    text: "Action",
    value: "actions",
    sortable: false,
    readonly: true,
    active: true,
  },
  {
    text: "Label",
    align: "start",
    sortable: true,
    value: "shortName",
    active: true,
  },
  {
    text: "Item Name",
    align: "start",
    sortable: true,
    value: "name",
    active: true,
  },
  // {
  //   text: "Tags",
  //   sortable: true,
  //   value: "tags",
  // },
  {
    text: "Type",
    sortable: true,
    value: "type",
    active: true,
  },
  {
    text: "Category",
    sortable: true,
    value: "categories",
    active: true,
  },
  {
    text: "Description",
    sortable: true,
    value: "description",
    active: true,
  },
  {
    text: "Cost",
    sortable: true,
    value: "cost",
    active: true,
  },
  {
    text: "Price",
    sortable: true,
    value: "price",
    active: true,
  },
  {
    text: "Date Modified",
    value: "lastUpdated",
    sortable: true,
    active: false,
  },
];
export default {
  mixins: [formatterMixin],
  components: {
    AddForm,
    DeleteDialog,
    Detail,
    TagsSelect,
    TagsChip,
  },
  data() {
    return {
      namespace: "Applications",
      page: "Item List",

      filter: {
        SearchTerm: null,
        type: null,
        tags: [],
      },

      tableOptions: {},
      
      showChangePassword: false,
      showDetail: false,
      showEdit: false,
      showDelete: false,
      selectedItem: "",

      noRecordFound: "No record found",

      clients: [],

      headers: defaultHeaders.map((item) => {
        let savedHeaders = getStorage(SETTING_LIST_KEY) || [];
        let nowHeader = savedHeaders.filter(
          (saved) => saved.value === item.value
        );

        if (nowHeader) {
          nowHeader = nowHeader[0];
        }
        return {
          ...item,
          ...nowHeader,
        };
      }),
    };
  },

  async created() {
    await this.refresh();
  },

  watch: {
    headers: {
      handler() {
        setStorage(SETTING_LIST_KEY, this.headers);
      },
      deep: true,
    },

    tableOptions: {
      async handler(n, o) {
        if (JSON.stringify(n) !== JSON.stringify(o)) {
          await this.refresh();
        }
      },
      deep: true,
    },
    filter: {
      async handler() {
        await this.refresh();
      },
      deep: true,
    },    
  },

  methods: {
    ...mapActions("item", ["clearTableFilter", "applyTableFilter"]),

    onDelete(item) {
      this.selectedItem = item;
      this.showDelete = true;
    },
    onNew() {
      this.selectedItem = {};
      this.showEdit = true;
    },
    onEdit(item) {
      if (!this.hasAccess("item.edit")) {
        return false;
      }
      this.selectedItem = item;
      this.showEdit = true;
    },
    onDetail(item) {
      this.selectedItem = item;
      this.showDetail = true;
    },
    clearDetail() {
      this.selectedItem = "";
      this.showDetail = false;
    },
    clearEdit() {
      this.selectedItem = "";
      this.showEdit = false;
    },
    clearDelete() {
      this.selectedItem = "";
      this.showDelete = false;
    },    

    refresh: _.debounce(async function () {
      this.applyTableFilter(this.computedFilter);
    }, 500),    
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      item: (state) => state.item,
      account: (state) => state.account,
      alert: (state) => state.alert,
      loading: (state) => state.item.loadingTable,
      totalItems: (state) => state.item.metaData.totalEntries
    }),
    activeHeaders() {
      return this.headers.filter((header) => header.active);
    },
    computedFilter() {
      let { SearchTerm, tags } = this.filter;
      let { sortBy, sortDesc, page, itemsPerPage } = this.tableOptions;
      let params = {
        PageNumber: page ? page : 1,
        PageSize: itemsPerPage > 0 ? itemsPerPage : 10,
      };

      if (SearchTerm) {
        params.SearchTerm = SearchTerm;
      }

      if (tags) {
        params.tags = tags;
      }

      if (sortBy.length > 0 && sortDesc.length > 0) {
        params.OrderBy = sortBy[0];
        params.Ascending = sortDesc[0] ? false : true;
      } else {
        params.Ascending = false;
      }
      return params;
    },    
  },

  beforeDestroy() {
    this.form = null;
    this.contacts = null;
    delete this.form;
    delete this.contacts;
    this.clearTableFilter();
  },
};
</script>